import { ArrowLeftOutlined, PrinterOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  ConfigProvider,
  Divider,
  Image,
  Row,
  Space,
  Table,
  Typography,
  theme,
} from 'antd';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { useAppSelector } from '../../../../app/hooks';
import { getImageUrl } from '../../../../common/utils/common.utils';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import { loadingIndicator } from '../../../../components/common/spinner/LoadingIndicator';
import NumToWord from '../../../../components/number_to_words/NumToWord';
import { PhoneParser } from '../../../../helpers/PhoneFormatter';
import { a4sizeStyle } from '../../../Loan_Management/Pages/Loan/ViewLoan';
import { useGetSingleTourRefundQuery } from '../../Api/Endpoints/TourPackageRefundEndpoints';
import {
  TourRefundViewTableColumn,
  TourRefundViewTableColumnClient,
} from '../../Utils/TourPackageUtils/TourRefundViewTableColumn';

type Props = {};

const ViewTourRefund = (props: Props) => {
  const { id } = useParams();
  const orgInfo = useAppSelector((state) => state.user?.organization_info);
  const { data: singleTourPackageRefund, isLoading } = useGetSingleTourRefundQuery(Number(id));
  console.log(singleTourPackageRefund?.data?.vendor_info);
  const [client_total_refund_amount, setClient_total_refund_amount] = useState<number>();

  let client_total_refund_price = 0;
  let client_total_refund_charge = 0;

  singleTourPackageRefund?.data &&
    singleTourPackageRefund?.data?.vendor_info?.forEach((item) => {
      client_total_refund_price =
        client_total_refund_price + Number(item?.vrefund_return_amount || 0);

      client_total_refund_charge =
        client_total_refund_charge + Number(item?.vrefund_charge_amount || 0);
    });

  useEffect(() => {
    if (singleTourPackageRefund?.data) {
      setClient_total_refund_amount(client_total_refund_price - client_total_refund_charge);
    }
  }, [singleTourPackageRefund?.data]);

  const componentRefClient = useRef(null);
  const refs: React.MutableRefObject<HTMLDivElement[]> = useRef([]);

  const handleClientPrint = useReactToPrint({
    content: () => componentRefClient.current,
    documentTitle: `TourPackageRefund`,
  });

  const { client_name, refund_amount, refund_charge, refund_note, payment_type } =
    singleTourPackageRefund?.data || {};

  return (
    <div>
      <BreadCrumb arrOfOption={['Refund', 'View Tour Package Refund Voucher']} />
      <Space style={{ marginBottom: '1rem' }}>
        <Link to='/refund/history/tour-package' state={location.pathname}>
          <Button type='primary'>
            <ArrowLeftOutlined />
            Return to Tour Package Refund List
          </Button>
        </Link>
      </Space>
      <ConfigProvider
        theme={{
          algorithm: theme.defaultAlgorithm,
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '40px',
          }}
        >
          <Card
            style={a4sizeStyle}
            title='Client Copy'
            extra={
              <Button type='primary' onClick={handleClientPrint}>
                <PrinterOutlined />
                Print
              </Button>
            }
          >
            <div ref={componentRefClient} style={{ margin: '0.5in' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <Image
                    style={{ marginBottom: '1rem' }}
                    width={100}
                    preview={false}
                    src={getImageUrl(orgInfo?.org_logo)}
                    alt={orgInfo?.org_name || 'M360 ICT'}
                  />
                  <Typography style={{ fontWeight: '700' }}>
                    {orgInfo?.org_name || 'M360 ICT'}
                  </Typography>
                </div>

                <div>
                  <Typography.Title level={5}>REFUND VOUCHER</Typography.Title>
                  <Typography.Text
                    strong
                  >{`Refund Voucher No : ${singleTourPackageRefund?.data?.voucher_no}`}</Typography.Text>
                  <br />
                  <Typography.Text strong>{`Refund Date : ${dayjs(
                    singleTourPackageRefund?.data?.create_date
                  ).format('DD MMM YYYY')}`}</Typography.Text>
                </div>
              </div>
              <div style={{ marginTop: '30px' }}>
                <Typography.Paragraph>
                  <br />
                  <Typography.Text strong>
                    {` Refund To : 
            ${singleTourPackageRefund?.data?.client_name}`}
                  </Typography.Text>
                  <br />
                  {/* <Typography.Text strong>
                    {singleTourPackageRefund?.data &&
                    singleTourPackageRefund?.data?.client_refund_info?.crefund_client_mobile ? (
                      `Phone No: ${PhoneParser(
                        singleTourPackageRefund?.data?.client_refund_info?.crefund_client_mobile
                      )}`
                    ) : (
                      <></>
                    )}
                  </Typography.Text> */}
                </Typography.Paragraph>
              </div>
              <Table
                size='small'
                bordered
                columns={TourRefundViewTableColumnClient()}
                dataSource={[{ client_name, refund_amount, refund_charge, payment_type }]}
                loading={{ spinning: isLoading, indicator: loadingIndicator }}
                className='invoiceBillingTable'
                rowClassName={'invoiceBillingTd'}
                style={{ marginTop: '1rem', marginBottom: '1rem' }}
                rowKey={(record) => record.vrefund_id}
                pagination={false}
                summary={(record) => {
                  return (
                    <>
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0} colSpan={2} align='right'>
                          <Typography style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            Total:
                          </Typography>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={2}>
                          <Typography style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            {refund_charge}
                          </Typography>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={3}>
                          <Typography
                            style={{
                              textAlign: 'right',
                              fontWeight: 'bold',
                            }}
                          >
                            {refund_amount}
                          </Typography>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>

                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0} colSpan={2}>
                          <Typography style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            Total Refund Amount:
                          </Typography>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={2}>
                          <Typography style={{ textAlign: 'right' }}>
                            ({refund_amount} - {refund_charge})
                          </Typography>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={3}>
                          <Typography style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            {Number(refund_amount || 0) - Number(refund_charge || 0)}
                          </Typography>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />

              <Typography.Text strong style={{ textAlign: 'right' }}>
                <NumToWord number={Number(refund_amount || 0) - Number(refund_charge || 0)} />
                Note : {refund_note}
              </Typography.Text>

              <Row></Row>
              <br />
              <Row
                gutter={{ xs: 8, sm: 16, md: 24, lg: 24 }}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  margin: '20px 0px',
                }}
              >
                <div style={{ width: '220px' }}>
                  <Divider orientation='left' plain>
                    Customer
                  </Divider>
                </div>
                <div style={{ width: '220px' }}>
                  <Divider orientation='left' plain>
                    Authorized
                  </Divider>
                </div>
              </Row>
            </div>
          </Card>
        </div>

        {/* Vendor Recipient */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '40px',
          }}
        >
          <Card
            style={a4sizeStyle}
            title='Vendor Copy'
            extra={
              <Button type='primary' onClick={handleClientPrint}>
                <PrinterOutlined />
                Print
              </Button>
            }
          >
            <div ref={componentRefClient} style={{ margin: '0.5in' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <Image
                    style={{ marginBottom: '1rem' }}
                    width={100}
                    preview={false}
                    src={getImageUrl(orgInfo?.org_logo)}
                    alt={orgInfo?.org_name || 'M360 ICT'}
                  />
                  <Typography style={{ fontWeight: '700' }}>
                    {orgInfo?.org_name || 'M360 ICT'}
                  </Typography>
                </div>

                <div>
                  <Typography.Title level={5}>REFUND VOUCHER</Typography.Title>
                  <Typography.Text
                    strong
                  >{`Refund Voucher No : ${singleTourPackageRefund?.data?.voucher_no}`}</Typography.Text>
                  <br />
                  <Typography.Text strong>{`Refund Date : ${dayjs(
                    singleTourPackageRefund?.data?.create_date
                  ).format('DD MMM YYYY')}`}</Typography.Text>
                </div>
              </div>
              <div style={{ marginTop: '30px' }}>
                <Typography.Paragraph>
                  <br />
                  <Typography.Text strong>
                    {` Refund To : 
            ${singleTourPackageRefund?.data?.client_name}`}
                  </Typography.Text>
                  <br />
                  {/* <Typography.Text strong>
                    {singleTourPackageRefund?.data &&
                    singleTourPackageRefund?.data?.client_refund_info?.crefund_client_mobile ? (
                      `Phone No: ${PhoneParser(
                        singleTourPackageRefund?.data?.client_refund_info?.crefund_client_mobile
                      )}`
                    ) : (
                      <></>
                    )}
                  </Typography.Text> */}
                </Typography.Paragraph>
              </div>
              <Table
                size='small'
                bordered
                columns={TourRefundViewTableColumn()}
                dataSource={singleTourPackageRefund?.data?.vendor_info}
                loading={{ spinning: isLoading, indicator: loadingIndicator }}
                className='invoiceBillingTable'
                rowClassName={'invoiceBillingTd'}
                style={{ marginTop: '1rem', marginBottom: '1rem' }}
                rowKey={(record) => record.vrefund_id}
                pagination={false}
                summary={(record) => {
                  return (
                    <>
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0} colSpan={2} align='right'>
                          <Typography style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            Total:
                          </Typography>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={2}>
                          <Typography style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            {client_total_refund_charge}
                          </Typography>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={3}>
                          <Typography
                            style={{
                              textAlign: 'right',
                              fontWeight: 'bold',
                            }}
                          >
                            {client_total_refund_price}
                          </Typography>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>

                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0} colSpan={2}>
                          <Typography style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            Total Refund Amount:
                          </Typography>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={2}>
                          <Typography style={{ textAlign: 'right' }}>
                            ({client_total_refund_price} - {client_total_refund_charge})
                          </Typography>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={3}>
                          <Typography style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            {client_total_refund_price - client_total_refund_charge}
                          </Typography>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />

              <Typography.Text strong style={{ textAlign: 'right' }}>
                <NumToWord
                  number={Number(client_total_refund_price - client_total_refund_charge || 0)}
                />
              </Typography.Text>

              <Row></Row>
              <br />
              <Row
                gutter={{ xs: 8, sm: 16, md: 24, lg: 24 }}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  margin: '20px 0px',
                }}
              >
                <div style={{ width: '220px' }}>
                  <Divider orientation='left' plain>
                    Customer
                  </Divider>
                </div>
                <div style={{ width: '220px' }}>
                  <Divider orientation='left' plain>
                    Authorized
                  </Divider>
                </div>
              </Row>
            </div>
          </Card>
        </div>
      </ConfigProvider>
    </div>
  );
};

export default ViewTourRefund;
